// ./mockData/mockEndpoints/mockAuth.js

import userData from '../userMockData.json';
import registrationData from '../registrationMockData.json';
import loginData from '../loginMockData.json';
import passwordChangeData from '../passwordChangeMockData.json';
import passwordResetData from '../passwordResetMockData.json';

export const mockAuth = {
  get: () => {
    return Promise.resolve({
      status: 200,
      body: { ...userData, pk: userData.id },
    });
  },

  registrationV2: (username, email, password1, password2, referrer_code) => {
    return Promise.resolve({
      status: 201,
      body: { key: registrationData.key },
    });
  },

  loginV2: (usernameOrEmail, password) => {
    return Promise.resolve({
      status: 200,
      body: { key: loginData.key },
    });
  },

  passwordChange: (old_password, new_password1, new_password2) => {
    return Promise.resolve({
      status: 200,
      body: passwordChangeData,
    });
  },

  passwordReset: email => {
    return Promise.resolve({
      status: 200,
      body: passwordResetData,
    });
  },

  passwordResetConfirm: (new_password1, new_password2, uid, token) => {
    return Promise.resolve({
      status: 200,
      body: { detail: 'Password reset confirmed' },
    });
  },
};
